const normalizeSelectValue = (value) => {
  if (value && typeof value === 'object' && 'value' in value) {
    return value.value;
  }
  return value ?? null;
};

const appendAttachments = (formData, attachments, existingAttachments) => {
  const keptIds = new Set(attachments.filter((file) => file.id).map((file) => file.id));
  const newFiles = attachments.filter((file) => !file.id);
  const removedFiles = existingAttachments.filter((file) => !keptIds.has(file.id));

  let index = 0;

  for (const file of newFiles) {
    const prefix = `ticket_comment[ticket_comment_attachments_attributes][${index}]`;
    formData.append(`${prefix}[document]`, file.originFileObj ?? file);
    formData.append(`${prefix}[name]`, file.name);
    index += 1;
  }

  for (const file of removedFiles) {
    const prefix = `ticket_comment[ticket_comment_attachments_attributes][${index}]`;
    formData.append(`${prefix}[id]`, file.id);
    formData.append(`${prefix}[_destroy]`, 'true');
    index += 1;
  }
};

const buildFormParams = ({ form, attachments = [], existingAttachments = [] }) => {
  const rawValues = form.getFieldsValue();
  const formData = new FormData();

  for (const [key, value] of Object.entries(rawValues)) {
    const normalized = key === 'author_id' ? normalizeSelectValue(value) : value ?? null;

    if (normalized !== null && normalized !== undefined) {
      formData.set(`ticket_comment[${key}]`, normalized);
    }
  }

  appendAttachments(formData, attachments, existingAttachments);

  return formData;
};

export default buildFormParams;
